module.exports = __webpack_public_path__ + "static/media/stock_up_32_blue.85e0b16a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/stock_up_32_blue.svg
// module id = 515
// module chunks = 0